import type { FaireProductEntity } from "../../entity_types/product";

export const p_fdb8q4z8ba: FaireProductEntity = {
  token: "p_fdb8q4z8ba",
  type: "product",
  name: "ROUND NECK SHORT SLEEVE KNIT SWEATER TOP",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/3b579fc888f3b3a003d1e6677cfe4547c763b20ae3365ba37ce67a37040e794d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6f64a939fb1674bc68e6d98efb9cc34611bd7c24d23a68a995da5174f29a15d.jpeg",
    "https://cdn.faire.com/fastly/5b844feac93e1972d28a882d38ed20392ecfa57a4e7b81ae93399e6d1747a4d3.jpeg",
    "https://cdn.faire.com/fastly/338bf71be62144375b22c6dabf6d69c55ba51d03e8ba636e1df0cf6508a56c4c.jpeg",
    "https://cdn.faire.com/fastly/3094a2a3269814281a346b7d54fc427c7eca73e04d7bad4fd35310793766c9f6.jpeg",
    "https://cdn.faire.com/fastly/0643fc89d9dc9f60b2fefe171246294ccc151b2c864bc78e176199eb4654181d.jpeg",
    "https://cdn.faire.com/fastly/a4a5e0f1776af7760fa75d20c42998cebc091bef73282865a71de038faee42d2.jpeg",
    "https://cdn.faire.com/fastly/73a5721113a53da7e2de906df1b5126f491ca45f446985708483c0570e08a818.jpeg",
    "https://cdn.faire.com/fastly/e4a953c0f4128ac3027c8f6be3dc96cc54b98c0c5453fad6fef2fefd753d87a5.jpeg",
    "https://cdn.faire.com/fastly/b3b306a0be14e859ec1f67a5821930208e78c38a6ad429dff5eb9a024613d556.jpeg",
    "https://cdn.faire.com/fastly/73556e04212b55971825c3c79094bb57a31491c5387d31c3613715e454b6b63d.jpeg",
    "https://cdn.faire.com/fastly/beb632a81df2c693d391fb5218353b8bbd3cd20fb34e42510ed6585bbd166e1a.jpeg",
    "https://cdn.faire.com/fastly/bbe22f692fb5af18bd4532b357f1f486bb7ecab47839474e514c13f7dfcb8962.jpeg",
    "https://cdn.faire.com/fastly/27aafaa46ca88ac2408e2d508cb4a878122157268b8d6d837ccd03b4f76edb54.jpeg",
    "https://cdn.faire.com/fastly/f9f1aa227700bcf446ca34c01981071e26ee0136fa2b745f2477ef5922a9483f.jpeg",
    "https://cdn.faire.com/fastly/796a3ff8560b009bcc4712f8bb0dd70217950ac6a51c13bc93167b4239e14e1e.jpeg",
    "https://cdn.faire.com/fastly/52f5ec2e242ac2fc1c2477b8212f0d65edceb1b04027b8653003780176a188e5.jpeg",
    "https://cdn.faire.com/fastly/9529eddaa4849aea929130fd1d968d321c44826e6e2de2555c28e9d3e0229932.jpeg",
    "https://cdn.faire.com/fastly/f32eefb179babb07852a6dd106eb2850623ab730d94bc5f9d21cc364c66341b9.jpeg",
    "https://cdn.faire.com/fastly/b794b30a750de1f6817a17eec2e677a7fd39e3038074794f5b8120ec51347d47.jpeg",
    "https://cdn.faire.com/fastly/229e0ca11c3e5331a611dd8324253628325bd01e6eea443c089c50e89ca94e2f.jpeg",
    "https://cdn.faire.com/fastly/7e27aa23a679492893d889a18b72fc27a1c11f3055e142208bcc3af5a80128d1.jpeg",
    "https://cdn.faire.com/fastly/10b2aa836b32896ad8dcc20a3479c685c61d00132eec9b4abc01404cfae97618.jpeg",
    "https://cdn.faire.com/fastly/e87deefd923077e948907403a0e2c567bb6baef1c9ea9c21840e0a5d29ea4c31.jpeg",
    "https://cdn.faire.com/fastly/9cee0d78b501218b946d1500e047af6d43ad37a6ff1cab4b7158984e58204f9b.jpeg",
    "https://cdn.faire.com/fastly/eadaebc09e456c342c5c55d464ce20f544560c527ef2d069cb6d32866a5776ac.jpeg",
    "https://cdn.faire.com/fastly/3cfbdd6b1a7fb958024656f26524861f2df18c9fdeef81a3fe2a056b3446b5ce.jpeg",
    "https://cdn.faire.com/fastly/aa887f0f64c2689ec24fab49935fa9c8e8a1450edebc53442c48fcbe5ddd7396.jpeg",
    "https://cdn.faire.com/fastly/74798c6876dbfc4eda5999e331b1177f310532e91c017595f48bb78fbb9afb00.jpeg",
    "https://cdn.faire.com/fastly/9246fe729043aec038da24634dca19e0fc6f9f10b846aac86e3a78c68db8b898.jpeg",
    "https://cdn.faire.com/fastly/d0ce82acadffeed8b08357246b7b1404b66756a55b8b17b1d3683a5a5b3a0e8c.jpeg",
    "https://cdn.faire.com/fastly/6811ec8eebb0fe541da20b9c2a6eb53eb50716189669396e06c223303e505307.jpeg",
    "https://cdn.faire.com/fastly/134861b7a7ca057e1904f8be74b045501013a5e07cd8578371124630184aba64.jpeg",
    "https://cdn.faire.com/fastly/a013557ec767cc746cf90094052d00f00c9aef3f664c4d6859331637ca6ce638.jpeg",
    "https://cdn.faire.com/fastly/26ca39d816f459c1c2f04aa2740e55a3352bec24c22b717232abefb4dda3ec2e.jpeg",
    "https://cdn.faire.com/fastly/13d9e916ee398b92a3ac069c73b34dbc7ef038c4627987188fad8b4cc224fac4.jpeg",
    "https://cdn.faire.com/fastly/254deb581eaddf57053a7128518b811a6c40ea48f683da6626181154ff32164e.jpeg",
    "https://cdn.faire.com/fastly/0ba1fc0f71f7eacbe81261a38d103365561e355bd72124a20cfb183d8b82bf50.jpeg",
    "https://cdn.faire.com/fastly/f779f1d44da757da7fa0d0403d1b07ded6d310445ab93627618e1659d692c49a.jpeg",
    "https://cdn.faire.com/fastly/794227278df4f95a056787247d013e9806c85ef57d04f311197acf061a050f4a.jpeg",
    "https://cdn.faire.com/fastly/7e6ffda7048323404100beb7d3ea80a8b5d4a74c745a8ea78d7fb6a53a11b699.jpeg",
    "https://cdn.faire.com/fastly/900bf9c24b4333a6519b01812e362a4809cce996ee41b8dfd20f025f53e3bd9b.jpeg",
    "https://cdn.faire.com/fastly/6ffca28745bf332c710817b2385c9af11cce5910d8f516c289b3bba7359d5644.jpeg",
    "https://cdn.faire.com/fastly/06842ff8378acd2115fffc8642150bb2ea4058b6c95d14f96f5514651a84b772.jpeg",
    "https://cdn.faire.com/fastly/3ce84aed61049f92aa4349adc55f20a8e5c6c8a9d89856d7049e3e91675b4c63.jpeg",
    "https://cdn.faire.com/fastly/d0fe7512cd31f4d671fdbb98f2f6514b832b869d058e15a54daa81b716536b50.jpeg",
    "https://cdn.faire.com/fastly/39d90a9199f5d5f6c5ecf2af6a18cedd2b3325767da0e9e36243453df3581651.jpeg",
    "https://cdn.faire.com/fastly/e550b0bc5cd67a8453d105719c352267391576d0f85c72575d7853ba57500174.jpeg",
    "https://cdn.faire.com/fastly/f343a568c735d1b56d9d0d7919e5a1c87192ffb5f680f3f57e80af6208e03710.jpeg",
    "https://cdn.faire.com/fastly/b070e16225d1f8a0edc6d8445c5b49c1d774632c4db211a7c3f4d5e635204225.jpeg",
    "https://cdn.faire.com/fastly/eb78b1633573308f973121660c71c2ce103406f6cb56d7b0e34c86881ce4c1d2.jpeg",
  ],
  priceDollars: 132,
  description:
    'Model is wearing a size small\n\n𝐌𝐎𝐃𝐄𝐋 𝐒𝐏𝐄𝐂𝐒\nHeight: 5\'8"\nBust: 32B\nWaist: 24"\nHips: 34"',
  tags: [],
  msrpDollars: 264,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:13.321Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
